// Must stay the first import: built-ins that Android WebView 91 lacks (T2-7361).
import './polyfills/legacyWebView'
import ReactDOM from 'react-dom'
import React from 'react'

import * as serviceWorker from './serviceWorker'
import App from './App'
import './index.css'
import { registerPaymentMethodSuccessBridge } from './utils/paymentMethodSuccessBridge'
import { initNativeAppShell } from './utils/nativeApp'
import Api from './api'
import { bootstrapWritingAssistV2Flag } from './utils/writingAssistV2'
import {
	getCeDirectoryAvailability,
	installCeDirectoryAvailabilityRefresh,
} from './features/ceDirectory/runtimeAvailability'

registerPaymentMethodSuccessBridge()
initNativeAppShell()

// react-pdf and its pdf.worker (~1.5 MB combined) used to initialise here via
// `import { pdfjs } from 'react-pdf'`, which forced the whole library into
// main.js on app startup. The worker is now configured on demand inside the
// lazy chunk `components/ResumeView/ResumePdfRenderer` — only users who
// actually view a resume pay the download cost.

const FLAG_BOOTSTRAP_TIMEOUT_MS = 2500

async function renderApp() {
	await bootstrapWritingAssistV2Flag(
		(signal) => Api.getClientFeatureFlags(signal),
		FLAG_BOOTSTRAP_TIMEOUT_MS,
	)

	const currentUserId = (window as any)?.TempStars?.User?.getCurrentUser?.()?.id
	await getCeDirectoryAvailability(currentUserId)
	installCeDirectoryAvailabilityRefresh(
		() => (window as any)?.TempStars?.User?.getCurrentUser?.()?.id,
		(signal) => Api.getClientFeatureFlags(signal),
	)

	// @ts-ignore
	ReactDOM.render((<App />), document.getElementById('root'))
}

void renderApp()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
